import { render } from "./SnailVideoPlayer.vue?vue&type=template&id=3cb20b92"
import script from "./SnailVideoPlayer.vue?vue&type=script&lang=js"
export * from "./SnailVideoPlayer.vue?vue&type=script&lang=js"

import "./SnailVideoPlayer.vue?vue&type=style&index=0&id=3cb20b92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__